import React from 'react';

function IconHighSvg() {
  return (
    <svg
      width="95"
      height="55"
      viewBox="0 0 95 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M90.1667 4L52.9583 41.2083L33.375 21.625L4 51"
        stroke="#800020"
        strokeWidth="7.83333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M66.6666 4H90.1666V27.5"
        stroke="#800020"
        strokeWidth="7.83333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default IconHighSvg;
